export const STEP_SEND_SMS = 'SEND_SMS';
export const STEP_ENTER_CODE = 'ENTER_CODE';
export const STEP_SUCCESS = 'SUCCESS';
